import { MaterialIcon } from 'mol-ui';
import PropTypes from 'prop-types';
import { theme } from 'styled';
import {
    ContentPercent,
    Image,
    Subtitle,
    Text,
    TextContainer,
    Title
} from './styled';
import React, { Component, Fragment } from 'react';

class Percentage extends Component {

    constructor () {
        super();
        this.state = {
            show: false
        };
    }

    _handleShow  = () => {
        this.setState(prevState => ({ show: !prevState.show }));
    };

    render () {
        const { dropwdown, icon, img, subtitle, text, title, plans } = this.props;
        const { show } = this.state;

        return (
            <Fragment>
                <TextContainer>
                    <Title>{ title }</Title>
                    {
                        dropwdown &&
                        <Subtitle onClick={ () => this._handleShow() }>{ dropwdown }</Subtitle>
                    }
                    {
                        subtitle && <Subtitle>{ subtitle }</Subtitle>
                    }
                </TextContainer>
                <ContentPercent>
                    { img && <Image alt={ title } src={ img } /> }
                    { icon && <MaterialIcon color={ theme.opacityColor } icon={ icon } size={ 40 } /> }
                    <Text>{ text }</Text>
                </ContentPercent>
            </Fragment>
        );
    }
}

Percentage.propTypes = {
    dropwdown: PropTypes.any,
    icon: PropTypes.string,
    img: PropTypes.string,
    plans: PropTypes.object,
    subtitle: PropTypes.string,
    text: PropTypes.string,
    title: PropTypes.string
};

Percentage.displayName = 'Percentage';

export default Percentage;
